<template>
  <div class="row f-row">
    <div class="row f-row spot-row mt-1 justify-content-center">
      <div
        class="col col-5 results-table-headers"
        v-if="selectedAssetLink === 0"
      >
        Currency:
      </div>
      <div class="col col-5 results-table-headers" v-else>
        Commodity:&nbsp;
        <i
          class="fa fa-question-circle txt-label-primary-2"
          style="display: inline; font-size: 1.3rem"
          @mouseover="onHoverHelp(true)"
          @mouseleave="onHoverHelp(false)"
        ></i>
      </div>
      <div class="col col-1"></div>
      <div class="col col-5 results-table-headers">
        Spot
      </div>
    </div>
    <div
      class="row f-row bdr-b spot-row justify-content-center"
      v-if="selectedAssetLink === 0"
    >
      <div class="col col-5 mb-1" style="z-index: 99999999!important;">
        <Dropdown
          v-if="selectedTabNotional === 0"
          :disabled="carouselPage !== 0"
          v-model="newSelectedAsset"
          :options="
            assetList.map(function(d, i) {
              return { asset: d.currency_name, id: i };
            })
          "
          @change="onUserAssetSelection"
          optionLabel="asset"
          optionValue="id"
          placeholder="Select a Currency"
          scrollHeight="400px"
          :filter="true"
        >
          <template #value="slotProps">
            {{ assetList[slotProps.value].currency_name.toUpperCase() }}
          </template>
          <template #option="slotProps">
            <div class="country-item">
              <div>{{ slotProps.option.asset.toUpperCase() }}</div>
            </div>
          </template>
        </Dropdown>
        <Dropdown
          v-else
          v-model="newSelectedAsset"
          :options="
            currencies.map(function(d, i) {
              return { asset: d, id: i };
            })
          "
          @change="onUserCurrencySelection"
          optionLabel="asset"
          optionValue="id"
          placeholder="Select a Currency"
          scrollHeight="400px"
          :filter="true"
        >
          <template #value="slotProps">
            {{ currencies[slotProps.value].toUpperCase() }}
          </template>
          <template #option="slotProps">
            <div class="country-item">
              <div>{{ slotProps.option.asset.toUpperCase() }}</div>
            </div>
          </template>
        </Dropdown>
      </div>
      <div class="col col-1 mb-1"></div>
      <div class="col col-1 analytics_results" v-if="showLoadingSpot">
        <span class="text-right" style="padding: 1px;">
          <QSLoading
            :isLoading="showLoadingSpot"
            :size="20"
            :colorTheme="colorTheme"
          />
        </span>
      </div>
      <div
        class="col mb-1"
        v-bind:class="[showLoadingSpot === true ? 'col-3' : 'col-4']"
      >
        <input
          v-model.number.lazy="newSpot"
          placeholder="spot"
          class="custom-input"
          @change="onUserSpotChange"
        />
      </div>
      <div
        class="col col-1 mb-1 text-center"
        style="padding-top: 1px!important; font-size: 1rem;"
      >
        <button class="btn updateSpot" v-on:click="onUserSpotRefresh">
          <i class="fa fa-refresh" style="font-size: 1.5rem"></i>
        </button>
      </div>
    </div>
    <div class="row f-row bdr-b spot-row justify-content-center" v-else>
      <div class="col col-5 mb-1" style="z-index: 99999999!important;">
        <Dropdown
          v-if="selectedTabNotional === 0"
          v-model="newSelectedAsset"
          :options="
            assetList.map(function(d, i) {
              return { asset: d.fk_idproduct, id: i };
            })
          "
          @change="onUserAssetSelection"
          optionLabel="asset"
          optionValue="id"
          placeholder="Select a Currency"
          scrollHeight="400px"
          :filter="true"
        >
          <template #value="slotProps">
            {{ assetList[slotProps.value].fk_idproduct.toUpperCase() }}
          </template>
          <template #option="slotProps">
            <div class="country-item">
              <div>{{ slotProps.option.asset.toUpperCase() }}</div>
            </div>
          </template>
        </Dropdown>
        <Dropdown
          v-else
          v-model="newSelectedAsset"
          :options="
            currencies.map(function(d, i) {
              return { asset: d, id: i };
            })
          "
          @change="onUserCurrencySelection"
          optionLabel="asset"
          optionValue="id"
          placeholder="Select a Currency"
          scrollHeight="400px"
          :filter="true"
        >
          <template #value="slotProps">
            {{ currencies[slotProps.value].toUpperCase() }}
          </template>
          <template #option="slotProps">
            <div class="country-item">
              <div>{{ slotProps.option.asset.toUpperCase() }}</div>
            </div>
          </template>
        </Dropdown>
      </div>
      <div class="col col-1 mb-1"></div>
      <div class="col col-1 analytics_results" v-if="showLoadingSpot">
        <span class="text-right" style="padding: 1px;">
          <QSLoading
            :isLoading="showLoadingSpot"
            :size="20"
            :colorTheme="colorTheme"
          />
        </span>
      </div>
      <div
        class="col mb-1"
        v-bind:class="[showLoadingSpot === true ? 'col-3' : 'col-4']"
      >
        <input
          v-model.number.lazy="newSpot"
          placeholder="spot"
          class="custom-input"
          @change="onUserSpotChange"
        />
      </div>
      <div
        class="col col-1 mb-1 text-center"
        style="padding-top: 1px!important;"
      >
        <button class="btn updateSpot" v-on:click="onUserSpotRefresh">
          <i class="fa fa-refresh" style="font-size: 1.5rem"></i>
        </button>
      </div>
    </div>
    <div class="row f-row mt-1">
      <div
        class="col col-12"
        style="overflow: auto;"
        v-bind:class="{
          strategiesHeight1: showCalculator && selectedStrategyLegs === 1,
          strategiesHeight2: showCalculator && selectedStrategyLegs === 2,
          strategiesHeight3: showCalculator && selectedStrategyLegs === 3,
          strategiesHeight: showCalculator && selectedStrategyLegs > 3,
        }"
      >
        <div
          v-for="(item, index) in newStrategies"
          v-bind:key="index"
          class="bdr-b"
        >
          <div
            class="row f-row"
            v-if="item.active"
            style="font-size: 0.95em; border-left: 3px solid transparent; transition: all 0.2s ease;"
            v-bind:class="{
              'background-selected': item.show && item.calculated,
            }"
          >
            <div class="col col-12" style="padding: 3px;">
              <div class="row f-row mb-1" style="height: 18px">
                <div
                  class="col col-12 text-center progress-div v-align"
                  v-if="!item.calculated"
                  v-bind:class="[
                    carouselPage === 0
                      ? 'hide-strategy-div'
                      : 'hide-strategy-div-2',
                  ]"
                >
                  <span v-if="carouselPage === 0"
                    >Complete Step 1 for Strategy Development</span
                  >
                  <button
                    v-else
                    type="button"
                    class="btn btn-strat h-50"
                    style="max-width: 120px"
                    v-on:click="onUserValuate(index)"
                  >
                    Calculate
                  </button>
                </div>
                <div
                  class="col col-12 text-center progress-div"
                  v-if="item.showLoading"
                >
                  <QSLoading
                    :isLoading="item.showLoading"
                    :size="40"
                    :colorTheme="colorTheme"
                  />
                </div>

                <div
                  class="col col-1 results-table-headers mt-1 d-flex"
                  style="height:100%; padding: 0; align-items:center;"
                >
                  <label
                    :for="item.id + '_button'"
                    class="toggle__button_g"
                    style="height: auto"
                    :class="{ active: item.show }"
                  >
                    <input
                      type="checkbox"
                      @click="onUserChangeStrategy(index)"
                      :id="item.id + '_button'"
                      v-model="item.show"
                    />
                    <span class="toggle__switch_g"></span>
                  </label>
                </div>
                <div class="col col-1 text-left">
                  <RiskImage :riskProfile="item.rProfile" :userWidth="'80%'" />
                </div>
                <div
                  class="col col-8"
                  style="font-size: 0.8em;margin-top: 2px;"
                >
                  {{ item.name }}
                </div>
                <div class="col col-2 text-right">
                  <button
                    v-if="isCurrency"
                    @click="downloadStrategyData(item)"
                    class="btn btn-up-dn-load"
                    type="submit"
                    style="font-size: 1rem;"
                  >
                    <i class="fa fa-download" aria-hidden="true"></i>
                  </button>
                  <button
                    class="btn btn-close"
                    style="font-size: 1rem;"
                    @click="onUserStrategyDelete(item)"
                  >
                    <span aria-hidden="true" style="padding: 0 8px 0 5px"
                      >&#10005;</span
                    >
                  </button>
                </div>
              </div>

              <div class="row f-row" v-if="carouselPage === 2">
                <div class="col col-9 mr-2 ml-2">
                  <Slider
                    v-model="item.percentage"
                    :step="1"
                    :min="0"
                    :max="100"
                    @slideEnd="(_) => onUserPercentageChange(index)"
                  />
                </div>
                <div
                  class="col col-cx mr-2"
                  style="font-size: 1em; margin-top: -2px; padding-top: -2px"
                >
                  <InputPercent
                    :stopEmitting="stopEmitting"
                    :readValue="readValue"
                    v-model="item.percentage"
                    @input="(_) => onUserPercentageChange(index)"
                  />
                </div>
              </div>

              <div class="row f-row">
                <div class="col col-12">
                  <table
                    class="table table-sm table-borderless strat-table"
                    style="width: 100%;"
                  >
                    <tbody>
                      <tr>
                        <td v-if="item.leg1 != null">
                          {{ item.leg1 }}
                          <InputNumber
                            v-if="item.calculated"
                            :borderBlue="item.objectiveLeg === 1 && item.show"
                            :deactivate="
                              !item.show ||
                                item.name === 'LONG FORWARD' ||
                                item.name === 'SHORT FORWARD' ||
                                item.name === 'LONG FUTURE' ||
                                item.name === 'SHORT FUTURE'
                            "
                            :value="item.strike1"
                            @input="(val) => onUserStrike1Change(val, item)"
                          />
                          <span v-else><br />...</span>
                        </td>
                        <td v-if="item.leg2 != null">
                          {{ item.leg2 }}
                          <InputNumber
                            v-if="item.calculated"
                            :borderBlue="item.objectiveLeg === 2 && item.show"
                            :deactivate="!item.show"
                            :value="item.strike2"
                            @input="(val) => onUserStrike2Change(val, item)"
                          />
                          <span v-else><br />...</span>
                        </td>
                        <td v-if="item.leg3 != null">
                          {{ item.leg3 }}
                          <InputNumber
                            v-if="item.calculated"
                            :borderBlue="item.objectiveLeg === 3 && item.show"
                            :deactivate="!item.show"
                            :value="item.strike3"
                            @input="(val) => onUserStrike3Change(val, item)"
                          />
                          <span v-else><br />...</span>
                        </td>
                        <td v-if="item.leg4 != null">
                          {{ item.leg4 }}
                          <InputNumber
                            v-if="item.calculated"
                            :borderBlue="item.objectiveLeg === 4 && item.show"
                            :deactivate="!item.show"
                            :value="item.strike4"
                            @input="(val) => onUserStrike4Change(val, item)"
                          />
                          <span v-else><br />...</span>
                        </td>
                        <td v-if="item.cost != null">
                          COST:
                          <span style="color: var(--textactive)">
                            {{ item.costPerc }}%
                          </span>
                          <span>
                            <i
                              v-show="
                                item.warning !== null &&
                                  item.warning !== undefined &&
                                  item.warning !== ''
                              "
                              class="fa fa-warning warn-my-data ml-3"
                              @mouseover="onHoverWarningQuestion(true)"
                              @mouseleave="onHoverWarningQuestion(false)"
                            ></i>
                          </span>
                          <InputNumber
                            v-if="item.calculated"
                            :borderBlue="!item.fixedCost && item.show"
                            :borderYellow="
                              item.warning !== null &&
                                item.warning !== undefined &&
                                item.warning !== ''
                            "
                            :deactivate="!item.show"
                            v-model="item.cost"
                            :value="item.cost"
                            @input="(val) => onUserCostChange(val, 1, item)"
                          />
                          <span v-else><br />...</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div
                    class="instructions-div-sidebar text-center"
                    v-if="showWarningDiv && item.show"
                  >
                    {{ item.warning }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="row f-row bdr-b justify-content-center"
      style="height: 5%"
      v-show="carouselPage > 0 && numStrats < 5"
    >
      <div
        class="col d-flex justify-content-center"
        v-bind:class="[carouselPage > 0 && !allValuated ? 'col-5' : 'col-8']"
      >
        <button
          type="button"
          class="btn btn-strat"
          v-on:click="onUserShowAllStrats"
          :class="{ active: showAllStrats }"
        >
          {{ !showAllStrats ? "Add strategy" : "Close" }}
        </button>
      </div>
      <div class="col col-1" v-show="carouselPage > 0 && !allValuated"></div>
      <div
        class="col col-5 d-flex justify-content-center"
        v-if="carouselPage > 0 && !allValuated"
      >
        <button
          type="button"
          class="btn btn-strat"
          v-on:click="onUserValuateAll"
        >
          Calculate all
        </button>
      </div>
    </div>
    <div
      class="row f-row bdr-b justify-content-center"
      style="height: 5%"
      v-show="carouselPage > 0 && numStrats >= 5 && !allValuated"
    >
      <div class="col col-8" v-show="carouselPage > 0 && !allValuated">
        <button
          type="button"
          class="btn btn-strat"
          v-on:click="onUserValuateAll"
        >
          CALCULATE ALL
        </button>
      </div>
    </div>

    <div
      class="row f-row mt-2 bdr-t"
      style="font-size: 0.8rem; padding: 5px; top: 30%; height: 30px; background: var(--background-alpha2);"
      v-show="carouselPage <= 1"
    >
      <div class="col col-12 text-center">
        Complete Step 2 Before Optimization
      </div>
    </div>
    <div class="row f-row" v-show="carouselPage === 2">
      <div class="col col-2" style="padding-left: 5px">
        <RiskImage :riskProfile="portfolio.rProfile" :userWidth="'50%'" />
      </div>
      <div class="col col-6" style="font-size: 0.64rem;padding-top: 6px">
        <span style="margin: 5px 0 0 5px;">Portfolio</span>
      </div>
      <div class="col col-1 text-right">
        <button
          @click="onPortfolioLockClick"
          class="btn-on-off btn mr-1"
          style="width: 15px;"
        >
          <i
            class="fa fa-lock active"
            style="color: var(--symmetry-h)!important;"
            v-if="newPortfolioPercLocked"
          ></i>
          <i class="fa fa-unlock" v-if="!newPortfolioPercLocked"></i>
        </button>
      </div>
      <div
        class="col col-cx mr-2 text-right"
        style="font-size: 0.8rem;margin-top: 2px;"
      >
        <InputPercent
          v-if="newPortfolioPercLocked"
          v-model="portfolio.objPercentage"
          :value="portfolio.objPercentage"
          @input="(val) => onUserObjPercentageChange(val)"
        />
        <InputPercent
          v-else
          :deactivate="true"
          v-model="portfolio.percentage"
        />
      </div>
    </div>
    <div
      class="row f-row mt-1"
      style="height: 28px"
      v-show="carouselPage === 2"
    >
      <div class="col col-2" style="font-size: 0.64rem;">
        <span style="margin: 5px 0 0 5px;">Cost:</span>
      </div>
      <div class="col col-cx mr-2 results-style" style="font-size: 1rem;">
        {{ portfolio.cost | numberFormat }}
        <sup style="padding-left:5px"
          >({{ portfolio.costPerc | percentageFormat }}%)</sup
        >
      </div>
    </div>
    <div
      class="row f-row mt-1"
      style="height: 28px"
      v-if="carouselPage > 0 && !isCurrency"
    >
      <div class="col col-cx" style="font-size: 0.64rem;">
        <span style="margin: 5px 0 0 5px;">Download:</span>
      </div>
      <div class="col col-8 mr-2 text-right" style="font-size: 0.64rem;">
        <button
          v-on:click="downloadStrategyData"
          type="submit"
          class="btn btn-up-dn-load"
        >
          <i class="fa fa-download" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { createExcel } from "@/_core/data/createExcel";
import {
  darkBackground,
  grayLightBackground,
  textactive2,
} from "@/_core/_helpers/_parametric_tools";
import { format, select, sum } from "d3";
import { getObjectiveLeg } from "@/_core/data/Optimizer";
import { SheetsTransaction } from "@/_core/export/SheetsTransaction";
import Dropdown from "primevue/dropdown";
import InputNumber from "@/components/InputNumber";
import InputPercent from "@/components/InputPercent";
import RiskImage from "@/components/optimizer/RiskImage";
import Slider from "primevue/slider";
import QSLoading from "@/components/QSLoading.vue";

export default {
  name: "strategiesEditor",
  components: {
    Dropdown,
    InputNumber,
    InputPercent,
    QSLoading,
    RiskImage,
    Slider,
  },
  props: {
    accumExcelData: { default: () => {} },
    allSimulated: { required: true, type: Boolean, default: false },
    allValuated: { required: true, type: Boolean, default: false },
    assetList: { required: true, default: () => [] },
    baseCurrency: { required: true, default: () => [] },
    carouselPage: { required: true, default: 0 },
    colorTheme: { required: true, type: Boolean, default: true },
    commodityDetails: { required: false, default: "" },
    companyName: { default: "" },
    contract: { required: false, default: 0 },
    currencies: { required: true, default: () => [] },
    excelData: { required: true, default: () => [] },
    notionalTotal: { required: true, default: 0 },
    isReadyStrategyValues: { required: true, type: Boolean },
    isCurrency: { required: false, type: Boolean, default: true },
    portfolioPercLocked: { required: true, type: Boolean, default: false },
    selectedAsset: { required: true, default: () => [] },
    selectedAssetLink: { required: true, default: 0 },
    selectedStrategyLegs: { required: true, default: 1 },
    selectedTabNotional: { required: true, default: 0 },
    showAllStrats: { required: true, type: Boolean, default: false },
    showCalculator: { required: true },
    showLoadingSpot: { required: true, type: Boolean, default: false },
    spot: { required: true },
    strategies: { required: true, default: () => [] },
  },
  data() {
    return {
      dataToExport: [],
      headersToExport: [],
      newPortfolioPercLocked: true,
      newSelectedAsset: 0,
      newSpot: 0,
      newStrategies: [],
      readyStrategyData: false,
      portfolio: {
        percentage: 100,
        objPercentage: 100,
        cost: 0,
        costPerc: 0,
        rProfile: 2,
      },
      readValue: true,
      showWarningDiv: false,
      signal1: require("@/assets/images/signal1.svg"),
      signal2: require("@/assets/images/signal2.svg"),
      signal3: require("@/assets/images/signal3.svg"),
      signal4: require("@/assets/images/signal4.svg"),
      signal5: require("@/assets/images/signal5.svg"),
      stopEmitting: false,
      strategyFileHeaders: [
        { text: "date", value: "date" },
        { text: "notional", value: "notional" },
        { text: "strike1", value: "leg1" },
        { text: "strike2", value: "leg2" },
        { text: "strike3", value: "leg3" },
        { text: "strike4", value: "leg4" },
      ],
      tooltip: null,
    };
  },
  created() {
    try {
      this.sheetTransaction = new SheetsTransaction(
        this.dataToExport,
        this.headersToExport,
      );
    } catch (error) {
      console.log(`Error Process Data ${error}`);
    }
  },
  mounted() {
    this.newStrategies = this.strategies;
    this.newPortfolioPercLocked = this.portfolioPercLocked;
    this.newSelectedAsset = this.selectedAsset;
    this.newSpot = this.spot;
    this.tooltip = select("#whole-page-opt-div")
      .append("div")
      .style("opacity", 0)
      .style("margin", 0)
      .style("padding", "8px")
      .style("text-align", "center")
      .style("background", darkBackground(this.colorTheme))
      .style("border", grayLightBackground(this.colorTheme))
      .style("color", textactive2(this.colorTheme))
      .attr("class", "tooltip")
      .style("font-size", "0.8rem")
      .style("width", "350px")
      .html("");
  },
  filters: {
    numberFormat: function(val) {
      return val === null || val === 0 ? "-" : format(",")(val);
    },
    percentageFormat: function(val) {
      return format(",.3")(val);
    },
  },
  watch: {
    colorTheme() {
      this.tooltip
        .style("background", darkBackground(this.colorTheme))
        .style("border", grayLightBackground(this.colorTheme))
        .style("color", textactive2(this.colorTheme));
    },
    numStrats(val) {
      if (val > 0) {
        if (this.newPortfolioPercLocked) {
          let percent = this.portfolio.objPercentage / this.strategies.length;
          this.newStrategies.forEach(function(d) {
            d.percentage = percent;
          });
          this.portfolio.percentage = this.portfolio.objPercentage;
        } else {
          this.portfolio.percentage = sum(this.newStrategies, function(d) {
            return d.percentage;
          });
        }
      }
    },
    portfolioCost(val) {
      this.portfolio.cost = val;
      this.portfolio.costPerc = (100 * val) / (this.spot * this.notionalTotal);
      this.$emit("eventOnPortfolioCostChange", val);
    },
    portfolioRisk(val) {
      this.portfolio.rProfile = val;
    },
    spot() {
      this.newSpot = this.spot;
    },
    selectedAsset() {
      this.newSelectedAsset = this.selectedAsset;
    },
    strategies(val) {
      this.newStrategies = val;
    },
    portfolioPercLocked(val) {
      this.newPortfolioPercLocked = val;
    },
    carouselPage(val) {
      if (val === 2) {
        if (this.newPortfolioPercLocked && this.newStrategies.length > 0) {
          let percent = this.portfolio.objPercentage / this.strategies.length;
          this.newStrategies.forEach(function(d) {
            d.percentage = percent;
          });
          this.portfolio.percentage = this.portfolio.objPercentage;
        }
      }
    },
    excelData(val) {
      let keys = Object.keys(val[0]);
      let len = keys.length;
      this.strategyFileHeaders =
        len === 3
          ? [
              { text: "pk", value: "date" },
              { text: "date", value: "date" },
              { text: "notional", value: "notional" },
              { text: val[0].label1, value: "leg1" },
            ]
          : len === 5
          ? [
              { text: "pk", value: "date" },
              { text: "date", value: "date" },
              { text: "notional", value: "notional" },
              { text: val[0].label1, value: "leg1" },
              { text: val[0].label2, value: "leg2" },
            ]
          : len === 7
          ? [
              { text: "pk", value: "date" },
              { text: "date", value: "date" },
              { text: "notional", value: "notional" },
              { text: val[0].label1, value: "leg1" },
              { text: val[0].label2, value: "leg2" },
              { text: val[0].label3, value: "leg3" },
            ]
          : [
              { text: "pk", value: "date" },
              { text: "date", value: "date" },
              { text: "notional", value: "notional" },
              { text: val[0].label1, value: "leg1" },
              { text: val[0].label2, value: "leg2" },
              { text: val[0].label3, value: "leg3" },
              { text: val[0].label4, value: "leg4" },
            ];
    },
  },
  computed: {
    numStrats() {
      return this.newStrategies.length;
    },
    portfolioCost() {
      return Math.round(
        sum(this.newStrategies, function(d) {
          return (d.percentage * d.cost) / 100;
        }),
      );
    },
    portfolioRisk() {
      return Math.round(
        sum(this.newStrategies, function(d) {
          return (d.percentage / 100) * d.rProfile;
        }),
      );
    },
  },
  methods: {
    configExcelFiles(strategy) {
      const legAndFiles = {
        leg1File1: {
          availableStrategies: ["FORWARD", "FUTURE"],
          file: 1,
        },
        leg1File2: {
          availableStrategies: ["CALL", "PUT"],
          file: 2,
        },
        leg2File3: {
          availableStrategies: [
            "COLLAR",
            "CALL SPREAD",
            "PUT SPREAD",
            "STRANGLE",
            "RATIO COLLAR",
          ],
          file: 3,
        },
        leg2File4: {
          availableStrategies: ["PARTICIPATING FORWARD", "FORWARD EXTRA"],
          file: 4,
        },
        leg3File5: {
          availableStrategies: [
            "BREAK FORWARD",
            "INVERSE SEAGULL",
            "SEAGULL",
            "BOOSTED FORWARD WITH CALL",
            "BOOSTED FORWARD WITH PUT",
          ],
          file: 5,
        },
        leg4File6: {
          availableStrategies: [
            "BOOSTED FORWARD",
            "IRON CONDOR",
            "CAPPED COLLAR",
          ],
          file: 6,
        },
      };

      for (let key in legAndFiles) {
        if (legAndFiles[key].availableStrategies.includes(strategy)) {
          return legAndFiles[key].file;
        }
      }

      return null;
    },
    onHoverHelp(val) {
      if (val) {
        this.tooltip
          .style("opacity", 1)
          .style("right", "30px")
          .style("top", "140px")
          .html(this.commodityDetails);
      } else {
        this.tooltip
          .style("right", "-1000000px")
          .style("top", "0px")
          .style("opacity", 0)
          .html("");
      }
    },
    // === portfolio optimization ===
    onPortfolioLockClick() {
      this.newPortfolioPercLocked = !this.newPortfolioPercLocked;
      if (this.newPortfolioPercLocked) {
        this.onUserObjPercentageChange(this.portfolio.objPercentage);
      }
      this.$emit("eventOnPortfolioLockClick", this.newPortfolioPercLocked);
    },
    onUserObjPercentageChange(val) {
      this.portfolio.objPercentage = Math.max(
        0,
        Math.min(100 * this.numStrats, val),
      );
      let numS = this.numStrats;
      let objP = this.portfolio.objPercentage;
      this.newStrategies.forEach(function(d) {
        d.percentage = Math.min(100, Math.max(0, objP / numS));
      });
      this.portfolio.percentage = objP;
    },
    onUserPercentageChange(idx) {
      if (this.newPortfolioPercLocked) {
        this.newStrategies[idx].percentage = Math.max(
          0,
          Math.min(
            this.newStrategies[idx].percentage,
            this.portfolio.objPercentage,
            100,
          ),
        );
        this.stopEmitting = true;
        this.readValue = false;
        this.portfolio.percentage = sum(this.newStrategies, function(d) {
          return d.percentage;
        });
        this.adjustPercentages(idx);
      } else {
        this.portfolio.percentage = sum(this.newStrategies, function(d) {
          return d.percentage;
        });
      }
      let percentageById = {};
      this.newStrategies.forEach(function(d) {
        percentageById[d.id] = d.percentage;
      });
      if (this.allSimulated) {
        this.$emit("eventOnUserWeightsChange", percentageById);
      }
      this.stopEmitting = false;
      this.readValue = true;
    },
    adjustPercentages(idx) {
      if (this.newPortfolioPercLocked && this.numStrats > 0) {
        if (this.portfolio.percentage === 0) {
          let percent = Math.min(
            100,
            Math.max(0, this.portfolio.objPercentage / this.strategies.length),
          );
          this.newStrategies.forEach(function(d) {
            d.percentage = percent;
          });
          this.portfolio.percentage = this.portfolio.objPercentage;
        } else {
          this.portfolio.percentage = sum(this.newStrategies, function(d) {
            return d.percentage;
          });
          let change = this.portfolio.percentage - this.portfolio.objPercentage;
          let otherPercentages = sum(this.newStrategies, function(d, i) {
            return i !== idx ? d.percentage : 0;
          });
          if (otherPercentages === 0) {
            let numS = this.numStrats;
            this.newStrategies.forEach(function(d, i) {
              d.percentage =
                i !== idx
                  ? Math.min(
                      100,
                      Math.max(0, d.percentage - change / (numS - 1)),
                    )
                  : d.percentage;
            });
          } else {
            let toOneHundred, tot;
            if (change < 0) {
              toOneHundred = this.newStrategies.map((d, i) =>
                i !== idx && d.percentage > 0 ? 100 - d.percentage : 0,
              );
            } else {
              toOneHundred = this.newStrategies.map((d, i) =>
                i !== idx && d.percentage > 0 ? d.percentage : 0,
              );
            }
            tot = toOneHundred.reduce((a, b) => a + b, 0);
            this.newStrategies.forEach(function(d, i) {
              d.percentage = Math.min(
                100,
                Math.max(0, d.percentage - (toOneHundred[i] / tot) * change),
              );
            });
          }
          this.portfolio.percentage = sum(this.newStrategies, function(d) {
            return d.percentage;
          });
        }
      } else {
        this.portfolio.percentage = sum(this.newStrategies, function(d) {
          return d.percentage;
        });
      }
    },
    // === calculator ===
    onUserStrike1Change(val, item) {
      if (item.show) {
        item.strike1 = val;
        if (item.first_second_strike_equal) {
          item.strike2 = item.strike1;
          if (item.fixedCost) {
            if (item.objectiveLeg === 1 || item.objectiveLeg === 2) {
              if (item.numLegs >= 3) {
                item.objectiveLeg = 3;
              } else {
                item.fixedCost = false;
                item.objectiveLeg = 0;
              }
            }
          }
        } else {
          if (item.fixedCost) {
            if (item.objectiveLeg === 1) {
              if (item.numLegs >= 2) {
                item.objectiveLeg = 2;
              } else {
                item.fixedCost = false;
                item.objectiveLeg = 0;
              }
            }
          }
        }
        this.$emit("eventOnUserCostChange", {
          idx: item.id,
          cost: item.cost,
          strategy: item,
          isStrip: getObjectiveLeg(item.objectiveLeg, item),
          editedLeg: 1,
          editedIsStrip: item.isStrip1,
          editedCurrAve: item.strike1,
          editedLegStripChanged: true,
        });
      }
    },
    onUserStrike2Change(val, item) {
      if (item.show) {
        item.strike2 = val;
        if (item.first_second_strike_equal) {
          item.strike1 = item.strike2;
          if (item.fixedCost) {
            if (item.objectiveLeg === 1 || item.objectiveLeg === 2) {
              if (item.numLegs >= 3) {
                item.objectiveLeg = 3;
              } else {
                item.fixedCost = false;
                item.objectiveLeg = 0;
              }
            }
          }
        } else {
          if (item.fixedCost) {
            if (item.objectiveLeg === 2) {
              item.objectiveLeg = 1;
            }
          }
        }
        this.$emit("eventOnUserCostChange", {
          idx: item.id,
          cost: item.cost,
          strategy: item,
          isStrip: getObjectiveLeg(item.objectiveLeg, item),
          editedLeg: 2,
          editedIsStrip: item.isStrip2,
          editedCurrAve: item.strike2,
          editedLegStripChanged: true,
        });
      }
    },
    onUserStrike3Change(val, item) {
      if (item.show) {
        item.strike3 = val;
        if (item.fixedCost) {
          if (item.objectiveLeg === 3) {
            item.objectiveLeg = 1;
          }
        }
        this.$emit("eventOnUserCostChange", {
          idx: item.id,
          cost: item.cost,
          strategy: item,
          isStrip: getObjectiveLeg(item.objectiveLeg, item),
          editedLeg: 3,
          editedIsStrip: item.isStrip3,
          editedCurrAve: item.strike3,
          editedLegStripChanged: true,
        });
      }
    },
    onUserStrike4Change(val, item) {
      if (item.show) {
        item.strike4 = val;
        if (item.fixedCost) {
          if (item.objectiveLeg === 4) {
            item.objectiveLeg = 1;
          }
        }
        this.$emit("eventOnUserCostChange", {
          idx: item.id,
          cost: item.cost,
          strategy: item,
          isStrip: getObjectiveLeg(item.objectiveLeg, item),
          editedLeg: 4,
          editedIsStrip: item.isStrip4,
          editedCurrAve: item.strike4,
          editedLegStripChanged: true,
        });
      }
    },
    onUserCostChange(val, curr, item) {
      if (item.show) {
        if (curr === 2) {
          val *= this.spot;
        }
        item.cost = val;
        if (item.fixedCost === false) {
          item.fixedCost = true;
          item.objectiveLeg = 1;
        }
        this.$emit("eventOnUserCostChange", {
          idx: item.id,
          cost: val,
          strategy: item,
          isStrip: getObjectiveLeg(item.objectiveLeg, item),
          editedLeg: 0,
          editedIsStrip: null,
          editedCurrAve: 0,
          editedLegStripChanged: false,
        });
      }
    },
    onUserValuate(idx) {
      this.$emit("eventOnUserValuate", idx);
    },
    onUserValuateAll() {
      this.$emit("eventOnUserValuateAll");
    },
    onUserShowAllStrats() {
      this.$emit("eventOnUserShowAllStrats", !this.showAllStrats);
    },
    onUserStrategyDelete(item) {
      this.newStrategies.splice(this.newStrategies.indexOf(item), 1);
      this.$emit("eventOnUserStrategyDelete", this.newStrategies);
    },
    onUserChangeStrategy(idx) {
      this.$emit("eventOnUserChangeStrategy", idx);
    },
    onUserAssetSelection() {
      this.$emit("eventOnUserAssetSelectionGeneral", this.newSelectedAsset);
    },
    // === general ===
    onUserSpotChange() {
      this.$emit("eventOnUserSpotChange", this.newSpot);
    },
    onUserSpotRefresh() {
      this.$emit("eventOnUserSpotRefresh");
    },
    onUserCurrencySelection() {
      this.$emit("eventOnUserCurrencySelection", this.newSelectedAsset);
    },
    async downloadStrategyData(item) {
      if (this.isCurrency) {
        const keysAccumExcelData = Object.keys(this.accumExcelData);
        const hasPk = !keysAccumExcelData.includes(String(item.pk));

        if (hasPk || !item.calculated) {
          this.onUserValuate(item.id);
        }

        const delayTime = 1000;
        // delay that allows to receive change of prop
        await new Promise((resolve) => {
          setTimeout(() => {
            resolve();
          }, delayTime);
        });

        while (!this.isReadyStrategyValues) {
          await new Promise((resolve) => setTimeout(resolve, 100));
        }

        let excelData;
        for (const key in this.accumExcelData) {
          if (key === String(item.pk)) {
            excelData = this.accumExcelData[key];
          }
        }

        const data = hasPk ? [...this.excelData] : excelData;
        const qtyDerivatives = item.numLegs;

        const keysData = [
          "fixing_date",
          "notional",
          "term",
          "spot_reference",
          "premium",
          "mark_2_market",
          "premium_currency",
          "strategy_name",
        ];

        const strikeKeys = Array.from(
          { length: qtyDerivatives },
          (_, i) => `strike${i + 1}`,
        );

        const legKeys = Array.from(
          { length: qtyDerivatives },
          (_, i) => `leg${i + 1}`,
        );
        const insertIndexStrike = keysData.findIndex((d) => d === "premium");
        keysData.splice(insertIndexStrike, 0, ...strikeKeys);

        const insertIndexLeg = insertIndexStrike + strikeKeys.length + 2;

        let strategyName = item.name.split(" ");
        strategyName.shift();
        const joinName = strategyName.join(" ");
        const numberFile = this.configExcelFiles(joinName);
        keysData.splice(insertIndexLeg, 0, ...legKeys);
        createExcel(
          this,
          "strategy",
          this.companyName,
          data,
          qtyDerivatives,
          keysData,
          numberFile,
        );
      } else {
        this.list_file = ["strategy"];
        this.headersToExport = this.strategyFileHeaders;
        this.sheetTransaction.set_data(this.excelData);
        this.sheetTransaction.set_headers(this.headersToExport);
        this.sheetTransaction.export(this.list_file);
      }
    },
    // === animations ===
    onHoverWarningQuestion(val) {
      this.showWarningDiv = val;
    },
  },
};
</script>

<style scoped>
.active .toggle__switch_g::after {
  left: calc(50% - 2px);
  background: var(--background);
  border: 1px solid var(--dark-expo);
  /* border: 1px solid var(--expo); */
  width: 50%;
  /* background: var(--expo); */
  /* box-shadow: 0 0 1px var(--expo); */
}
.active .toggle__switch_g {
  background: var(--dark-expo);
  /* box-shadow: inset 0 0 1px var(--graylightbackground); */
}
.toggle__button_g .toggle__switch_g::after,
.toggle__button_g .toggle__switch_g::before {
  content: "";
}
</style>
